import React from 'react';
import TransactionModule from './transaction.module';
import ProductCmms from 'enums/products-cmms';

const TransactionSCModule = () => {
  return (
    <div>
      <TransactionModule product={ProductCmms.SharedCapital} />
    </div>
  );
};

export default TransactionSCModule;
